import { apiClient } from "@/lib/apiClient";

export const onboardingService = {
  async get() { return (await apiClient.get("/onboarding")).data; },
  async start() { return (await apiClient.post("/onboarding/start")).data; },
  async skipStep(step) { return (await apiClient.post(`/onboarding/steps/${step}/skip`)).data; },
  async completeStep(step) { return (await apiClient.post(`/onboarding/steps/${step}/complete`)).data; },
  async dismiss() { return (await apiClient.post("/onboarding/dismiss")).data; },
  async reset() { return (await apiClient.post("/onboarding/reset")).data; },
};
